import React from "react";
import {FarmyButton} from "../../../react-components/shared/SharedComponents";
import {t} from "../../../shared-services/translate";
import {PriceSuperscript} from "../../products/useProductPrice";
import {Link} from "react-router-dom";

const CartSidebarCTAButton = (props) => {
  const {currentCart, currency, className = "", style} = props;

  return <Link to={"/cart"} className={className} style={style}>
    <FarmyButton size="custom" color="orange" className="border-radius-md full-width font-size-body">
      <div className="flex align-items-center justify-content-center gap-10">
        <div>
          {t("go_to_cart")}
        </div>

        <div>
          <span className="font-size-body-smaller margin-right-3">{currency}</span>
          <PriceSuperscript
            price={currentCart?.cart_summary?.item_total_incl_wc_surcharge}
            fontSize="16px"
          />
        </div>
      </div>
    </FarmyButton>
  </Link>;
};

export default CartSidebarCTAButton;
